import { Anchor, Card, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconConcealFilled } from '@zillow/constellation-icons';
import { APPLICATIONS_FAQ_URL, LANDLORD_SCREENING_FAQ_URL, PRIVACY_POLICY } from '@zg-rentals/applications-utils';
import { useTermSet } from '../IdvContext';
import { TermSet } from '../../../models';

function LandlordContent() {
  return (
    <>
      <Heading level={2} textStyle="body-lg-bold" css={{ marginBottom: 'default' }}>
        How your user data is handled
      </Heading>
      <Paragraph css={{ marginBottom: 'loose' }}>
        Verifying your identity is an important part of protecting your rental applicants’ data.
      </Paragraph>
      <Paragraph css={{ marginBottom: 'loose' }}>
        We’ll only ask as many question as needed to verify your identity. Your answers are securely passed to Experian
        and CIC without being stored by Zillow, and with no impact to your credit score.
      </Paragraph>
      <Paragraph>
        See our{' '}
        <Anchor href={PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
          privacy policy
        </Anchor>{' '}
        and{' '}
        <Anchor href={LANDLORD_SCREENING_FAQ_URL} target="_blank" rel="noopener noreferrer">
          FAQ
        </Anchor>{' '}
        for more details.
      </Paragraph>
    </>
  );
}

function RenterContent() {
  return (
    <>
      <Heading level={2} textStyle="body-lg-bold" css={{ marginBottom: 'default' }}>
        Protecting your data
      </Heading>
      <Paragraph css={{ marginBottom: 'loose' }}>
        We only share your credit and background check reports with identity-verified rental managers.
      </Paragraph>
      <Paragraph css={{ marginBottom: 'loose' }}>
        We limit our questions to what’s needed to create these reports. Your answers are securely passed to Experian
        and CIC without being stored by Zillow.
      </Paragraph>
      <Paragraph>
        See our{' '}
        <Anchor href={PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
          privacy policy
        </Anchor>{' '}
        and{' '}
        <Anchor href={APPLICATIONS_FAQ_URL} target="_blank" rel="noopener noreferrer">
          FAQ
        </Anchor>{' '}
        for more details.
      </Paragraph>
    </>
  );
}

export default function PrivacyCard() {
  const termSet = useTermSet();

  return (
    <Card tone="soft" elevated={false} css={{ marginLeft: { xl: 'looser' } }}>
      <Icon size="xl" css={{ marginBottom: 'default' }}>
        <IconConcealFilled />
      </Icon>
      {termSet === TermSet.LandlordScreening ? <LandlordContent /> : <RenterContent />}
    </Card>
  );
}
